// How a subscription's status looks, in one place.
//
// The same word appears on the plan card, the payment method card and the
// billing summary, and each used to decide its own colour - "Cancelled" came
// out amber in two of them and green in the third, which read as three
// different states rather than one.

/**
 * @param {string} status from GET /billing/subscription: active, past_due,
 *   cancelled or ended
 * @returns {string} the bill-badge modifier to apply
 */
export const statusTone = (status) => {
  switch (String(status || "").toLowerCase()) {
    case "active":
      return "bill-badge--active";
    // Still working, but on its way out or needing attention.
    case "cancelled":
    case "past_due":
      return "bill-badge--pending";
    // Over: nothing is being served.
    case "ended":
      return "bill-badge--ended";
    default:
      return "bill-badge--pending";
  }
};

/** The badge's full className, so callers don't assemble it themselves. */
export const statusBadgeClass = (status) => `bill-badge ${statusTone(status)}`;
